<div class="color-picker-field">
  <div class="color-input-wrapper">
    <input
      #colorPickerInput
      type="text"
      [formControl]="formControl"
      class="form-control color-input"
      [class.is-invalid]="showError"
      [formlyAttributes]="field"
      [(colorPicker)]="formControl.value"
      [cpPosition]="props.colorPickerPosition"
      [cpOutputFormat]="props.colorPickerOutputFormat"
      [cpAlphaChannel]="props.colorPickerAlphaChannel"
      (colorPickerChange)="onColorChange($event)"
      [ngStyle]="{ 'border-left-color': formControl.value, 'border-left-width': '4px' }" />
    <div
      *ngIf="props.showPreview"
      class="color-preview"
      [style.background-color]="formControl.value"
      [colorPicker]="formControl.value"
      [cpPosition]="props.colorPickerPosition"
      [cpOutputFormat]="props.colorPickerOutputFormat"
      [cpAlphaChannel]="props.colorPickerAlphaChannel"
      (colorPickerChange)="onColorChange($event)"
      [cpDialogDisplay]="'popup'"
      title="Click to open color picker">
    </div>
  </div>
</div>
